import unescapedText from 'I18n/utils/unescapedText';
export function translateProductType(type) {
  switch (type) {
    case 'AGENT':
      return unescapedText('trellisEcosystem.productType.AGENT');
    case 'APP':
      return unescapedText('trellisEcosystem.productType.APP');
    case 'MODULE':
      return unescapedText('trellisEcosystem.productType.MODULE');
    case 'THEME':
      return unescapedText('trellisEcosystem.productType.THEME');
    default:
      // Log error for unknown product type
      console.error(`Unknown product type encountered: ${type}`);
      return type;
  }
}